<template>
  <div class="m-0 bar"></div>
</template>

<script>
export default {
  name: "DividerVue",
};
</script>
